export enum EnumFileExtension {
  PDF = 'pdf',
}

export enum EnumFileFormat {
  CSV = 'csv',
  PDF = 'pdf',
}
